import { Component } from "@angular/core";
import { YesNoDialogData } from "./yes-no-dialog-data";
import { DialogBase } from "../dialog-base";

@Component({
    standalone: false,
    selector: 'yes-no-dialog',
    templateUrl: './yes-no-dialog.component.html',
    styleUrls: ['./yes-no-dialog.component.scss']    
})

export class YesNoDialogComponent extends DialogBase<YesNoDialogComponent, YesNoDialogData> {
    yes(): void {
        this.close(true);
    }

    no(): void {
        this.close(false);
    }
}
